/** @jsx jsx */
import { ReactNode } from 'react';
import { jsx, css } from '@emotion/react';
import { TabList } from '@atlaskit/tabs';

const tabListStyles = css({
  /** this is to offset the tab list to the existing design, and can be removed if/when this changes */
  position: 'relative',
  /** this is to offset the tab list to sit flush with the child container */
  marginLeft: '-0.5rem',
  '> *::before': {
    right: '0 !important',
  },
});

interface TabProps {
  children: ReactNode;
}

const Tab = ({ children }: TabProps) => (
  <div css={tabListStyles}>
    <TabList>{children}</TabList>
  </div>
);

export default Tab;
